import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

type Props = {
  marginBottom?: string | number;
};

const useStyles = createUseStyles((_) => ({
  container: {
    marginBottom: (props: Props) =>
      props.marginBottom ? props.marginBottom : "15px",
  },
  formControl: {
    "&.MuiFormControl-root": {
      width: "100%",
      marginTop: "5px",
      // ROOT CAUSE of "Service: 9".
      //
      // A MUI Select renders TWO things stacked in the same box:
      //   * div.MuiSelect-select     - the visible display, whose text comes
      //                                from renderValue() / the matching
      //                                MenuItem, i.e. "Technique".
      //   * input.MuiSelect-nativeInput - a hidden form input carrying the RAW
      //                                value, i.e. 9. MUI ships it at
      //                                opacity: 0, position: absolute.
      //
      // These rules used to be inverted: `& input` (which matches ONLY the
      // native input - a Select has no other <input>) forced opacity: 1, and
      // `.MuiSelect-select.MuiSelect-outlined` was set to opacity: 0. So every
      // select in the app displayed its raw value and hid its label.
      //
      // It went unnoticed for so long because most selects are fed plain
      // strings, where value === label ("Mensuel" shows "Mensuel"). Only
      // id/label options exposed it - the Service field, whose value is a
      // department id. That is also why fixing renderValue in
      // CustomTextSelect.tsx never changed anything: the correct label WAS
      // being rendered, into an element with opacity: 0.
      //
      // Keep the native input invisible (its only job is form submission) and
      // style the display element instead.
      "& .MuiSelect-nativeInput": {
        opacity: 0,
      },
      "& fieldset": {
        border: "none",
      },
      "& .MuiInputBase-root.MuiOutlinedInput-root": {
        fontFamily: "Poppins-Regular",
        backgroundColor: colors.elevatedSurface,
        border: `1px solid ${colors.borderDark}`,
        borderRadius: "50px",
        fontSize: "13px",
        color: colors.BLACK,
        padding: 0,
        "& .MuiSelect-select": {
          opacity: 1,
          padding: "10px",
          paddingLeft: "23px",
          fontFamily: "Poppins-Regular",
          fontSize: "13px",
        },
      },
    },
  },
  /** Greyed text shown by renderValue when nothing is selected yet. */
  placeholder: {
    color: "#b6b5b5",
  },
  containerLabel: {
    paddingLeft: "26px",
  },
}));
export default useStyles;
